import { HardDrive, Cloud, Folder } from "lucide-react";

export type DocumentStoreType =
  | "All"
  | "LOCAL"
  | "GOOGLE DRIVE"
  | "DROPBOX"
  | "ONEDRIVE";

/**
 * Get the icon component for a document store type
 * @param source - The document store type
 * @returns React component with appropriate icon and styling
 */
export const getSourceIcon = (source: string) => {
  switch (source) {
    case "LOCAL":
      return <HardDrive className="h-4 w-4 text-blue-500" />;
    case "GOOGLE DRIVE":
      return <Cloud className="h-4 w-4 text-green-500" />;
    case "DROPBOX":
      return <Cloud className="h-4 w-4 text-blue-600" />;
    case "ONEDRIVE":
      return <Cloud className="h-4 w-4 text-sky-500" />;
    case "All":
      return <Folder className="h-4 w-4 text-blue-500" />;
    default:
      return <Folder className="h-4 w-4 text-blue-500" />;
  }
};

/**
 * Get the display name for a document store type
 * @param type - The document store type
 * @returns User-friendly display name
 */
export const getDisplayName = (type: string) => {
  switch (type) {
    case "LOCAL":
      return "Local";
    case "GOOGLE DRIVE":
      return "Google Drive";
    case "DROPBOX":
      return "Dropbox";
    case "ONEDRIVE":
      return "OneDrive";
    case "All":
      return "All";
    default:
      return type;
  }
};

/**
 * Format a date string to a user-friendly format
 * @param dateString - ISO date string
 * @returns Formatted date string (e.g., "Jan 15, 2024")
 */
export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

/**
 * List of all available document store tabs
 */
export const DOCUMENT_STORE_TABS: readonly DocumentStoreType[] = [
  "All",
  "LOCAL",
  "GOOGLE DRIVE",
  "DROPBOX",
  "ONEDRIVE",
] as const;
